import { render, staticRenderFns } from "./ClockIcon.vue?vue&type=template&id=4fbc0149&scoped=true&"
import script from "./ClockIcon.vue?vue&type=script&lang=js&"
export * from "./ClockIcon.vue?vue&type=script&lang=js&"
import style0 from "./ClockIcon.vue?vue&type=style&index=0&id=4fbc0149&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbc0149",
  null
  
)

export default component.exports